import { Col, Form, Input } from "antd";
import { CATEGORY_406 } from "constantes";
import React from "react";

const ChassisNumberField=({categoryCode, disable, xs, md })=> {
    
    if([CATEGORY_406].includes(categoryCode)) return null;
    
    return (
        <React.Fragment>
            <Col className="gutter-row" xs={xs ?? 12} md={md ?? 6}>
                <Form.Item
                    label="Numero de chassis"
                    name="chassisNumber"
                    rules={[{ required: true, message: "Champ obligatoire" }]}
                >
                    <Input
                        size='large'
                        placeholder='Numero de chassis du vehicule'
                        disabled={disable}
                    />
                </Form.Item>
            </Col>
            
        </React.Fragment>
    )
}

export default ChassisNumberField;